import styled from 'styled-components';

export const Container = styled.div({
  position: 'relative',
});

export const OnTrend = styled.div(({ theme }) => ({
  background: theme.defaultTheme.trendColor,
  color: theme.palette.white,
  fontSize: '12rem',
  padding: '0 10rem',
  position: 'absolute',
  top: '5rem',
}));
